import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from '@albo-ui/core';
import { TextField, MenuItem, Select, InputLabel, FormControl, Divider, Grid, FormControlLabel, Checkbox } from '@mui/material';
import { useConfigRegister } from './hooks/useConfigRegister';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

export type ConfigFraudProps = {
    onConfirm: (data: any) => void;
    onClose: () => void;
    open: boolean;
    title: string;
    operation: any;
    channel: any;
    error: boolean;
    catalogs: any;
    update?: any;
    origin?: string;
} & DefaultComponentProps;

export const ConfigFraudDialog = ({ onConfirm, onClose, open, title, operation, channel, error, catalogs, update, origin }: ConfigFraudProps) => {
    const { form, isValidForm, catalogType, dataType, isUpdate, updateCount, errors, fieldName, onAddItem, onDeleteItem, onHandleType, onHandleChange } = useConfigRegister(open, error, update, origin)

    const tab = (name, item) => {
        return (
            <Grid container item xs={12} spacing={2}>
                <Grid item container alignItems={'center'}>
                    <strong>{name}</strong>
                    {form[item]?.length > 0 && <AddIcon onClick={() => onAddItem(item)} sx={{paddingLeft: '5px', cursor: 'pointer'}}/> }
                </Grid>
                <Grid item sx={{paddingTop: '3px !important'}} width={'inherit'}><Divider /></Grid>
            </Grid>
        )
    }
    const defineInitialVal = (type, value, prop=null, key) => {
        switch (type) {
            case 'datetime-local':
                return <TextField type={type} value={value ? value.slice(0,-4) : ''} onChange={onHandleChange.bind(this, 'accumulators', prop || 'value', key)} label='Dato' color='secondary' sx={{width: 600}} size='small' InputLabelProps={{ shrink: true }} error={errors['accumulators'][key] && errors['accumulators'][key][prop || 'value']}/>
            case 'number':
                return <TextField type={type} value={value || 0 } onChange={onHandleChange.bind(this, 'accumulators', prop || 'value', key)} label='Dato' color='secondary' sx={{width: 600}} size='small' InputLabelProps={{ shrink: true }} error={errors['accumulators'][key] && errors['accumulators'][key][prop || 'value']}/>
            case 'boolean':
                return <FormControl color='secondary' sx={{width: 600}} size='small'>
                    <InputLabel>Dato</InputLabel>
                    <Select value={value || '-1'} onChange={onHandleChange.bind(this, 'accumulators', prop || 'value', key)} label='Dato' color='secondary' MenuProps={{style: {zIndex: 35001}}} error={errors['accumulators'][key] && errors['accumulators'][key][prop || 'value']} >
                        <MenuItem value={'-1'} disabled>Seleccione</MenuItem>
                        <MenuItem value={'true'}>True</MenuItem>
                        <MenuItem value={'false'}>False</MenuItem>
                    </Select>
                </FormControl>
            default:
                return <TextField type={type} value={value || ''} onChange={onHandleChange.bind(this, 'accumulators', prop || 'value', key)} label='Dato' color='secondary' sx={{width: 600}} size='small' InputLabelProps={{ shrink: true }} error={errors['accumulators'][key] && errors['accumulators'][key][prop || 'value']}/>
        }
    }

    const accumulatorsBase = (item?: any, key?: number, show=false) => {
        return (
            <FlexGrid key={`accumulator-${key}`} container spacing={2} fullWidth>
                <TextField value={item?.name || ''} disabled={isUpdate && key < updateCount.accumulators} onInput={onHandleChange.bind(this, 'accumulators', 'name', key)} label='Nombre' color='secondary' fullWidth size='small' autoFocus error={errors['accumulators'][key] && errors['accumulators'][key]['name']}/>
                <TextField value={item?.description || ''} onInput={onHandleChange.bind(this, 'accumulators', 'description', key)} label='Descripción' color='secondary' fullWidth size='small' error={errors['accumulators'][key] && errors['accumulators'][key]['description']}/>
                <FormControl color='secondary' sx={{width: 600}} size='small'>
                    <InputLabel>Tipo de dato</InputLabel>
                    <Select value={dataType[key || 0]?.key || '-1'} onChange={onHandleType.bind(this, key)} label='Tipo de dato' color='secondary' MenuProps={{style: {zIndex: 35001}}} >
                        <MenuItem value={-1} disabled>Seleccione</MenuItem>
                        {catalogType?.map((item) => (
                            <MenuItem key={`type-${item?.key}`} value={item?.key}>{item?.label}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {dataType[key || 0]?.catalog &&
                    <FormControl color='secondary' sx={{width: 600}} size='small'>
                        <InputLabel>{dataType[key || 0]?.label}</InputLabel>
                        <Select value={item?.value || '-1'} onChange={onHandleChange.bind(this, 'accumulators', 'value', key)} label={dataType[key || 0]?.label} color='secondary' MenuProps={{style: {zIndex: 35001}}} error={errors['accumulators'][key] && errors['accumulators'][key]['value']}>
                            <MenuItem value={-1} disabled>Seleccione</MenuItem>
                            {catalogs[dataType[key || 0]?.key]?.map((item) => (
                                <MenuItem key={`type-${item?.k}`} value={item?.k}>{item?.v}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
                {!dataType[key || 0]?.catalog && 
                    defineInitialVal(dataType[key || 0]?.key, item?.value, null, key)
                }
                {show && key >= updateCount.accumulators && <DeleteOutlineIcon onClick={() => onDeleteItem('accumulators', key)} sx={{margin: 'auto', cursor: 'pointer'}}/>}
            </FlexGrid>
        )
    }

    const accumulatorSpecial = (prop: string, value?: any, key?: number) => {
        return (
            <FlexGrid key={`accumulator-${key}`} container spacing={2} fullWidth>
                <TextField value={prop || ''} disabled={isUpdate} label='Nombre' color='secondary' fullWidth size='small'/>
                <FormControl color='secondary' sx={{width: 600}} size='small'>
                    <InputLabel>Tipo de dato</InputLabel>
                    <Select value={dataType[key || 0]?.key || '-1'} onChange={onHandleType.bind(this, key)} label='Tipo de dato' color='secondary' MenuProps={{style: {zIndex: 35001}}} >
                        <MenuItem value={-1} disabled>Seleccione</MenuItem>
                        {catalogType?.map((item) => (
                            <MenuItem key={`type-${item?.key}`} value={item?.key}>{item?.label}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {dataType[key || 0]?.catalog &&
                    <FormControl color='secondary' sx={{width: 600}} size='small'>
                        <InputLabel>{dataType[key || 0]?.label}</InputLabel>
                        <Select value={value || '-1'} onChange={onHandleChange.bind(this, 'accumulators', prop, key)} label={dataType[key || 0]?.label} color='secondary' MenuProps={{style: {zIndex: 35001}}} error={errors['accumulators'][key] && errors['accumulators'][key][prop]}>
                            <MenuItem value={-1} disabled>Seleccione</MenuItem>
                            {catalogs[dataType[key || 0]?.key]?.map((item) => (
                                <MenuItem key={`type-${item?.k}`} value={item?.k}>{item?.v}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
                {!dataType[key || 0]?.catalog && 
                    defineInitialVal(dataType[key || 0]?.key, value, prop, key)
                }
            </FlexGrid>
        )
    }

    const field_expiredBase = (item?: any, key?: number, show=false) => {
        return (
            <FlexGrid key={`${fieldName}-${key}`} container spacing={2} fullWidth>
                <TextField value={item?.path || ''} disabled={isUpdate && key < updateCount[fieldName]} onChange={onHandleChange.bind(this, fieldName, 'path', key)} label='Path' color='secondary' fullWidth size='small' autoFocus error={errors[fieldName][key] && errors[fieldName][key]['path']}/>
                <TextField value={item?.value || 0} onChange={onHandleChange.bind(this, fieldName, 'value', key)} label='Dato' color='secondary' fullWidth size='small' error={errors[fieldName][key] && errors[fieldName][key]['value']}/>
                <TextField value={item?.expired_date?.slice(0,-4) || ''} type='datetime-local' onChange={onHandleChange.bind(this, fieldName, 'expired_date', key)} label='Fecha expiración' color='secondary' fullWidth size='small' InputLabelProps={{ shrink: true}} error={errors[fieldName][key] && errors[fieldName][key]['expired_date']}/>
                <TextField value={item?.delta_expired || 3600} type='number' onChange={onHandleChange.bind(this, fieldName, 'delta_expired', key)} label='Delta' color='secondary' sx={{width: '40%'}} size='small' InputLabelProps={{ shrink: true}} InputProps={{endAdornment: "s"}} error={errors[fieldName][key] && errors[fieldName][key]['delta_expired']}/>
                <FormControlLabel control={<Checkbox checked={item?.evaluate || true} onChange={onHandleChange.bind(this, fieldName, 'evaluate', key)} color='secondary'/>} label={'Evaluar'} />
                {show && key >= updateCount[fieldName] && <DeleteOutlineIcon onClick={() => onDeleteItem(fieldName, key)} sx={{margin: 'auto', cursor: 'pointer'}}/>}
            </FlexGrid>
        )
    }

    // const rebootsBase = (item?: any, key?: number, show=false) => {
    //     return (
    //         <FlexGrid key={`reboots-${key}`} container spacing={2} fullWidth>
    //             <TextField value={item?.name || ''} disabled={isUpdate && key < updateCount.reboots} onChange={onHandleChange.bind(this, 'reboots', 'name', key)} label='Nombre' color='secondary' fullWidth size='small' autoFocus error={errors['reboots'][key] && errors['reboots'][key]['name']}/>
    //             <TextField value={item?.expired_date?.slice(0,-4) || ''} type='datetime-local' onChange={onHandleChange.bind(this, 'reboots', 'expired_date', key)} label='Fecha expiración' color='secondary' fullWidth size='small' InputLabelProps={{ shrink: true}} error={errors['reboots'][key] && errors['reboots'][key]['expired_date']}/>
    //             <TextField value={item?.delta_expired || 3600} type='number' onChange={onHandleChange.bind(this, 'reboots', 'delta_expired', key)} label='Delta' color='secondary' sx={{width: '40%'}} size='small' InputLabelProps={{ shrink: true}} InputProps={{endAdornment: "s"}} error={errors['reboots'][key] && errors['reboots'][key]['delta_expired']}/>
    //             <FormControlLabel control={<Checkbox checked={item?.evaluate || true} onChange={onHandleChange.bind(this, 'reboots', 'evaluate', key)} color='secondary'/>} label={'Evaluar'} />
    //             {show && key >= updateCount.reboots && <DeleteOutlineIcon onClick={() => onDeleteItem('reboots', key)} sx={{margin: 'auto', cursor: 'pointer'}}/>}
    //         </FlexGrid>
    //     )
    // }

    return (
        <Dialog onClose={onClose} open={open} style={{minWidth: '1000px', maxHeight: '500px'}}>
	        <DialogTitle>
				<Typography variant='h2'>{title}</Typography>
			</DialogTitle>
			<DialogContent>
                <FlexGrid container direction='column' alignItems='flex-start' spacing={2}>
                    <FlexGrid container spacing={2} fullWidth>
                        <FormControl color='secondary' fullWidth>
                            <InputLabel>Canal</InputLabel>
                            <Select value={form.channel || '-1'} onChange={onHandleChange.bind(this, null, 'channel', null)} label='Canal' color='secondary' MenuProps={{style: {zIndex: 35001}}} error={errors['channel']}>
                                <MenuItem value={-1} disabled>Canal</MenuItem>
                                {channel?.map((item) => (
                                    <MenuItem key={`channel-${item.key}`} value={item.value}>{item.label}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl color='secondary' fullWidth>
                            <InputLabel>Operación</InputLabel>
                            <Select value={form.operation || '-1'} onChange={onHandleChange.bind(this, null, 'operation', null)} label='Operación' color='secondary' MenuProps={{style: {zIndex: 35001}}} error={errors['operation']}>
                                <MenuItem value={-1} disabled>Operación</MenuItem>
                                {operation?.map((item) => (
                                    <MenuItem key={`operation-${item.key}`} value={item.value}>{item.label}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </FlexGrid>
                    <Divider/>
                    {tab('Acumuladores', 'accumulators')}
                    {!origin && (form.accumulators?.length > 0 ?
                        form.accumulators?.map((item, key) => accumulatorsBase(item, key, true))
                        :  accumulatorsBase())
                    }
                    {Object.keys(form.accumulators).length > 0 && origin &&
                        Object.keys(form.accumulators)?.map((prop, key) => accumulatorSpecial(prop, form.accumulators[prop], key))
                    }                
                    {tab('Campos de Expiración', fieldName)}
                    {form[fieldName]?.length > 0 ?
                        form[fieldName]?.map((item, key) => field_expiredBase(item, key, true))
                        :  field_expiredBase()
                    }
                    {/* {tab('Reboots', 'reboots')}
                    {form.reboots?.length > 0 ?
                        form.reboots?.map((item, key) => rebootsBase(item, key, true))
                        :  rebootsBase()
                    } */}
                </FlexGrid>
			</DialogContent>
			<DialogActions>
				<FlexGrid container fullHeight fullWidth justify='space-between' alignItems='flex-end' style={{ marginTop: '20px' }}>
					<FlexGrid item>
						<Button onClick={onClose} buttonType='secondary' size='normal'>
							Cancelar
						</Button>
					</FlexGrid>
					<FlexGrid item>
						<Button onClick={() => onConfirm(form)} disabled={isValidForm} size='normal'>
							Aceptar
						</Button>
					</FlexGrid>
				</FlexGrid>
			</DialogActions>
        </Dialog>
    )
}